import { useSearchParams } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';
import { useQuery } from '@tanstack/react-query';
import { fetchLearnerHomeInit } from '@blend-ed/blendxplatform/api';
import { getFeatureToggle } from '@blend-ed/blendxplatform/utils';
import { Tabs, Tab } from '@openedx/paragon';

import './courses/Courses.scss';
import NotesSection from './courses/NotesSection';
import EnrollmentsGrid from './courses/EnrollmentsGrid';
import messages from './courses/messages';
import { useEnrolledPrograms } from '../gql/hooks/useEnrolledPrograms';
import { useEnrolledPathways } from '../gql/hooks/useEnrolledPathways';

const VALID_TABS = ['courses', 'notes'];

const Courses = () => {
  const { formatMessage } = useIntl();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : 'courses';

  const setActiveTab = (tab) => {
    setSearchParams(tab === 'courses' ? {} : { tab }, { replace: true });
  };

  const { data: learnerHomeInit } = useQuery({
    queryKey: ['learnerHomeInit'],
    queryFn: fetchLearnerHomeInit,
  });

  const featuresToggled = getFeatureToggle();
  const programsEnabled = featuresToggled.features_programs !== false;
  const pathwaysEnabled = featuresToggled.features_learning_pathway === true;
  const { enrolledPrograms, loading: programsLoading } = useEnrolledPrograms(programsEnabled);
  const { enrolledPathways, loading: pathwaysLoading } = useEnrolledPathways(pathwaysEnabled);

  const courseCount = (learnerHomeInit?.courses || []).length;
  const programCount = programsEnabled ? enrolledPrograms.length : 0;
  const pathwayCount = pathwaysEnabled ? enrolledPathways.length : 0;

  const isEmpty = !!learnerHomeInit
    && !programsLoading
    && !pathwaysLoading
    && courseCount === 0
    && programCount === 0
    && pathwayCount === 0;

  if (isEmpty) {
    return (
      <div className="courses-page">
        <EnrollmentsGrid />
      </div>
    );
  }

  const enrollmentsTabTitle = formatMessage(messages.myLearningTab);

  return (
    <div className="courses-page">
      <div className="courses-page__tabs">
        <Tabs
          activeKey={activeTab}
          onSelect={(key) => key && setActiveTab(key)}
        >
          <Tab eventKey="courses" title={enrollmentsTabTitle}>
            <EnrollmentsGrid />
          </Tab>
          <Tab eventKey="notes" title={formatMessage(messages.notesTab)}>
            <NotesSection />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Courses;
